import { forceLogout } from "../contexts/AuthContext";

export async function authFetch(url, options = {}) {
  const token = localStorage.getItem("adm_panel_token");

  const res = await fetch(url, {
    ...options,
    headers: {
      ...(options.headers || {}),
      Token: token || "",
    },
  });

  if (res.status === 401) {
    console.warn("401 Unauthorized → forced logout");
    forceLogout();
    throw new Error("Unauthorized");
  }

  return res;
}
